import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { COUNT_BADGE, ICON_BUTTON } from './glass';

const TONES = {
  default: 'tw-text-slate-600 hover:tw-text-slate-900 dark:tw-text-slate-300 dark:hover:tw-text-white',
  accent: 'tw-text-teal-700 hover:tw-text-teal-800 dark:tw-text-teal-300 dark:hover:tw-text-teal-200',
  alert: 'tw-text-rose-600 hover:tw-text-rose-700 dark:tw-text-rose-300 dark:hover:tw-text-rose-200',
};

/** Round glass icon button with an optional count badge. */
const IconButton = forwardRef(({ label, badge = 0, tone = 'default', className = '', children, ...rest }, ref) => (
  <button
    ref={ref}
    type="button"
    title={label}
    aria-label={badge > 0 ? `${label} (${badge})` : label}
    className={`${ICON_BUTTON} ${TONES[tone]} ${className}`}
    {...rest}
  >
    {children}
    {badge > 0 && (
      <span aria-hidden="true" className={COUNT_BADGE}>
        {badge > 99 ? '99+' : badge}
      </span>
    )}
  </button>
));

IconButton.displayName = 'IconButton';

IconButton.propTypes = {
  label: PropTypes.string.isRequired,
  badge: PropTypes.number,
  tone: PropTypes.oneOf(Object.keys(TONES)),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default IconButton;
